import { useEffect, useRef, useState } from 'react';

/**
 * Observes the presence of the PostHog survey modal and returns its state.
 */
export function usePostHogSurveyObserver(): boolean {
  const [isOpen, setIsOpen] = useState(false);
  const isOpenRef = useRef(false);

  useEffect(() => {
    const CLASS_PREFIX = 'PostHogSurvey-';

    const check = () => {
      const el = document.querySelector(`[class^="${CLASS_PREFIX}"]`);

      const next = !!el;

      if (next !== isOpenRef.current) {
        isOpenRef.current = next;
        setIsOpen(next);
      }
    };

    const observer = new MutationObserver(check);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    check();

    return () => observer.disconnect();
  }, []);

  return isOpen;
}
